import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'
import * as StaffActions from 'libs/gb-dashboard/staff/data-access/src/lib/+state/staff.actions'
import { StaffEntity } from './staff.models'

export const STAFF_FEATURE_KEY = 'staff'

export interface StaffState extends EntityState<StaffEntity> {
  selectedId?: string | number
  loaded: boolean
  exportReportLoaded: boolean
  createInvalidationLoaded: boolean
}

export const staffAdapter: EntityAdapter<StaffEntity> = createEntityAdapter<StaffEntity>({
  selectId: (staff: StaffEntity) => staff.id,
})

export const initialStaffState: StaffState = staffAdapter.getInitialState({
  loaded: false,
  exportReportLoaded: true,
  createInvalidationLoaded: true,
})

const reducer = createReducer(
  initialStaffState,
  on(StaffActions.exportStaffReport, StaffActions.exportVoucherReport, (state) => ({
    ...state,
    exportReportLoaded: false,
  })),
  on(
    StaffActions.exportStaffReportFailure,
    StaffActions.exportStaffReportSuccess,
    StaffActions.downloadStaffReportSuccess,
    (state) => ({
      ...state,
      exportReportLoaded: true,
    }),
  ),
)

export function staffReducer(state: StaffState | undefined, action: Action) {
  return reducer(state, action)
}
